import React from 'react';
import { useTranslation } from 'react-i18next';
import { Field, reduxForm } from 'redux-form';

import Typography from '@material-ui/core/Typography';

import HelpIcon from '@material-ui/icons/Help';

import { DEFAULT_LANGUAGE } from 'pages/create-activity/constants';
import { TRANSLATIONS } from 'translations/index';

import {
  FormActionButtons,
  MultipleSelectField,
  TextareaInput,
  ChipsInput,
  PopoverWrapper
} from 'components';

import validate from './validate';

import { useStyles } from './styles';

const DescriptionCreate = ({
  handleSubmit,
  setSubmitButton,
  isUpdate,
  ...otherProps
}) => {
  const {
    languages,
    selectedLanguage,
    addLanguage,
    deleteLanguage,
    selectLanguage
  } = otherProps;
  const [t] = useTranslation();

  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <Typography variant="h1" className={classes.title}>
        {t('Description')}
      </Typography>
      <MultipleSelectField
        availableItems={[]}
        notAvailableToDeleteItems={[DEFAULT_LANGUAGE]}
        list={languages}
        selectedItem={selectedLanguage}
        addItem={addLanguage}
        deleteItem={deleteLanguage}
        selectItem={selectLanguage}
      />
      <form onSubmit={handleSubmit}>
        <Field
          name={`overview`}
          className={classes.inputIndent}
          label={`${TRANSLATIONS[selectedLanguage].generalInfo} *`}
          placeholder={`${TRANSLATIONS[selectedLanguage].generalInfo}`}
          maxLength="2000"
          component={TextareaInput}
          isTranslateError={true}
          language={selectedLanguage}
        />
        <Field
          name={`whatToBring`}
          id={'whatToBring'}
          className={classes.inputIndent}
          label={
            <div className={classes.labelWithHelpIcon}>
              <span>{t(TRANSLATIONS[selectedLanguage].whatToBring)}</span>
              <PopoverWrapper
                text={`${TRANSLATIONS[selectedLanguage].includedHelpMessage}`}
              >
                <HelpIcon className={classes.helpIcon} />
              </PopoverWrapper>
            </div>
          }
          placeholder={
            TRANSLATIONS[selectedLanguage]['Hit Enter to add an item']
          }
          maxLength="1000"
          component={ChipsInput}
        />
        <Field
          name={`additionalInfo`}
          className={classes.inputIndent}
          label={`${TRANSLATIONS[selectedLanguage].additionalInfo}`}
          placeholder={`${TRANSLATIONS[selectedLanguage].additionalInfo}`}
          maxLength="1000"
          component={TextareaInput}
          isTranslateError={true}
          language={selectedLanguage}
        />
        <Field
          name={`cancellation`}
          className={classes.inputIndent}
          label={
            <div className={classes.labelWithHelpIcon}>
              <span>{t(TRANSLATIONS[selectedLanguage].cancellation)} *</span>
              <PopoverWrapper
                text={`${TRANSLATIONS[selectedLanguage].cancellationHelpMessage}`}
              >
                <HelpIcon className={classes.helpIcon} />
              </PopoverWrapper>
            </div>
          }
          placeholder={`${TRANSLATIONS[selectedLanguage].cancellation}`}
          maxLength="1000"
          component={TextareaInput}
          isTranslateError={true}
          language={selectedLanguage}
        />
        <Field
          name={`included`}
          id={'included'}
          className={classes.inputIndent}
          label={
            <div className={classes.labelWithHelpIcon}>
              <span>{t(TRANSLATIONS[selectedLanguage].included)}</span>
              <PopoverWrapper
                text={`${TRANSLATIONS[selectedLanguage].includedHelpMessage}`}
              >
                <HelpIcon className={classes.helpIcon} />
              </PopoverWrapper>
            </div>
          }
          placeholder={
            TRANSLATIONS[selectedLanguage]['Hit Enter to add an item']
          }
          maxLength="1000"
          component={ChipsInput}
        />
        <Field
          name={`notIncluded`}
          id={'notIncluded'}
          className={classes.inputIndent}
          label={
            <div className={classes.labelWithHelpIcon}>
              <span>{t(TRANSLATIONS[selectedLanguage].notIncluded)}</span>
              <PopoverWrapper
                text={`${TRANSLATIONS[selectedLanguage].includedHelpMessage}`}
              >
                <HelpIcon className={classes.helpIcon} />
              </PopoverWrapper>
            </div>
          }
          placeholder={
            TRANSLATIONS[selectedLanguage]['Hit Enter to add an item']
          }
          maxLength="1000"
          component={ChipsInput}
        />
        <FormActionButtons
          cancelPath="/accommodations-and-activities"
          actionLabel="Next"
          setSubmitButton={setSubmitButton}
          isUpdate={isUpdate}
        />
      </form>
    </div>
  );
};

export default reduxForm({
  form: 'descriptionForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
  touchOnBlur: false,
  validate
})(DescriptionCreate);
